<div class="general-warning-modal modal-content-radius-16">
  <!-- Header -->
  <div class="modal-container">
    <div class="modal-header">
      <svg
        class="warning-icon"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        ></path>
      </svg>
      <h3 class="modal-title">{{title}}</h3>
    </div>

    <div class="modal-body">
      <p *ngIf="subtitle" class="modal-subtitle" [innerHTML]="subtitle"></p>
      <p *ngIf="content" class="modal-content-text" [innerHTML]="content"></p>

      <ng-container #dynamicContent></ng-container>

      <div class="notice" *ngFor="let notice of notices">
        <span class="notice-title"
          >⚠️ <span [innerHTML]="notice?.title"></span
        ></span>
        <ul>
          <li
            *ngFor="let noticeItem of notice?.list"
            [innerHTML]="noticeItem"
          ></li>
        </ul>
      </div>

      <form
        class="options-wrapper"
        *ngIf="options?.length"
        [formGroup]="confirmFormGroup"
      >
        <ng-container formArrayName="options">
          <ng-container
            *ngFor="let optionForm of options?.controls; let i = index"
          >
            <ng-container [formGroupName]="i">
              <div class="checkbox-group">
                <input
                  type="checkbox"
                  [id]="_options[i].id"
                  formControlName="confirm"
                />
                <label
                  [htmlFor]="_options[i].id"
                  class="checkbox-label"
                  [ngClass]="{ required: _options[i].required }"
                  [innerHTML]="_options[i].desc"
                >
                </label>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </form>
    </div>

    <div class="modal-footer actions">
      <button class="btn cancel" (click)="onCancel()">Cancel</button>
      <button
        type="button"
        class="btn confirm"
        [disabled]="confirmFormGroup.invalid"
        [ngStyle]="{
          cursor: !confirmFormGroup.invalid ? 'pointer' : 'not-allowed'
        }"
        (click)="onConfirm()"
      >
        {{ confirmText || "Confirm" }}
      </button>
    </div>
  </div>
</div>
